module.exports = __webpack_public_path__ + "static/media/smart-banner-logo.c40fdf4d.png";